export const logoutSessionExpired = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");

  window.location.href = "/login-admin";

  alert("Tu sesion ha expirado. Por favor inicia sesion nuevamente.");
};
